import { observer } from "mobx-react";
import React from "react";
import { PositionedSpinner } from "../../../../../../../../components/ui/PositionedSpinner";
import { ImpactBusinessAreasSidebarModel } from "./ImpactBusinessAreasSidebar_model";
import { SingleForm } from "../../../../../../../../pages/change/forms/singleFormModel/SingleForm_view";

export interface ImpactBusinessAreasSidebarProps {
  model: ImpactBusinessAreasSidebarModel;
}

export const ImpactBusinessAreasSidebar: React.FC<ImpactBusinessAreasSidebarProps> = observer(({ model }) => {
  if (model.isLoading) return <PositionedSpinner />;

  return (
    <div className="container-fluid">
      <SingleForm model={model.formModel} />
    </div>
  );
});
